import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectEditorState = (state: RootState) => state.editorState;

export const selectSpaValue = createSelector(
  selectEditorState,
  (state) => state.spaValue,
);

export const selectSpaUriObject = createSelector(selectSpaValue, (state) => {
  if (state === null) return;
  return state.spa_object?.uri_object;
});

export const selectIsMessageLoading = createSelector(
  selectEditorState,
  (state) => state.isMessageLoading,
);

export const selectIsFileLoading = createSelector(
  selectEditorState,
  (state) => state.isFileLoading,
);

export const selectEditorMessages = createSelector(
  selectEditorState,
  (state) => state.messages,
);

export const selectIsLegacySpaObject = createSelector(
  [selectSpaValue],
  (value) => {
    const isLegacy = value?.spa_object?.metadata?.isLegacyObject;

    return isLegacy ?? true;
  },
);
